import './legal.css'

import {FC, ReactNode} from 'react'

import {LEGAL_KINDS, legalFooter, LegalLang, legalPath, legalYear} from '../../legal/legal-helpers'

type LegalFooterProps = {
  lang: LegalLang
  /** Only the three links (kiosk-like, embedded payment screens). */
  compact?: boolean
  /** Same tab (legal pages themselves). In a booking flow keep the default: a new tab. */
  sameTab?: boolean
  year?: number
  /** Extra text at the end of the links row (the app version). */
  extra?: ReactNode
}

export const LegalFooter: FC<LegalFooterProps> = ({lang, compact = false, sameTab = false, year, extra}) => {
  const footer = legalFooter(lang)
  const shownYear = legalYear(lang, year ?? new Date().getFullYear())
  return (
    <footer
      className='legal-footer'
      data-testid='legal-footer'
      lang={lang}
    >
      <nav
        className='legal-footer__links'
        aria-label='Legal'
      >
        {LEGAL_KINDS.map((kind) => (
          <a
            key={kind}
            href={legalPath(kind, lang)}
            {...(sameTab ? {} : {target: '_blank', rel: 'noopener noreferrer'})}
          >
            {footer[kind]}
          </a>
        ))}
        {extra}
      </nav>
      {!compact && <p className='legal-footer__line'>{`© ${shownYear} ${footer.line}`}</p>}
    </footer>
  )
}
